import React from 'react';
import 'intersection-observer';
import Observer from '@researchgate/react-intersection-observer';
import PropTypes from 'prop-types';
import getContext from 'recompose/getContext';
import withContext from 'recompose/withContext';

class ObserverFlag extends React.PureComponent {
    state = {
        isVisible: true
    };

    handleChange = ({ intersectionRatio, isIntersecting }) => {
        const { onChange, intersectionId, threshold } = this.props;
        const isVisible = isIntersecting && intersectionRatio >= threshold;
        onChange &&
            onChange({
                intersectionId,
                isVisible
            });
        this.setState({ isVisible });
    };

    onObserverRef = node => {
        this.observer = node;
    };

    render() {
        const { threshold, rootMargin, child, rootNode, disable } = this.props;
        const { isVisible } = this.state;
        return (
            <Observer
                ref={this.onObserverRef}
                threshold={threshold}
                rootMargin={rootMargin}
                disabled={!rootNode || !child || disable}
                root={rootNode}
                onChange={this.handleChange}
            >
                {isVisible
                    ? child
                    : React.cloneElement(child, {
                          style: { ...child.props.style, visibility: 'hidden' }
                      })}
            </Observer>
        );
    }
}

const withObserver = ({ threshold, rootMargin }) => {
    return Component => {
        class ObserverWrap extends React.PureComponent {
            state = {
                isVisible: true
            };

            handleChange = ({ intersectionRatio, isIntersecting }) => {
                const isVisible =
                    isIntersecting && intersectionRatio >= threshold;
                this.setState({ isVisible });
            };

            render() {
                const { rootNode, disable, ...others } = this.props;
                const { isVisible } = this.state;
                return (
                    <Observer
                        threshold={threshold}
                        rootMargin={rootMargin}
                        disabled={typeof rootNode === 'undefined' || disable}
                        root={rootNode}
                        onChange={this.handleChange}
                    >
                        <Component {...others} isVisible={isVisible} />
                    </Observer>
                );
            }
        }
        return getContext(contextType)(ObserverWrap);
    };
};

ObserverFlag.defaultProps = {
    threshold: 1
};

const contextType = {
    rootNode: PropTypes.element
};

const TransparentComponent = ({ className, style, children }) => {
    return (
        <div className={className} style={style}>
            {children}
        </div>
    );
};

const ObserverProvider = withContext(contextType, ({ rootNode }) => ({
    rootNode
}))(TransparentComponent);

export default ObserverFlag;

export { withObserver, ObserverFlag, ObserverProvider };
